import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { formatDate } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { VacationTransService } from 'src/app/services/VacationTransService';
import { VacationTransModel } from 'src/app/models/VacationTransModel';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { DoctorsModel } from 'src/app/models/DoctorsModel';

@Component({
  selector: 'app-vaction-request-search',
  templateUrl: './vaction-request-search.component.html',
  styleUrls: ['./vaction-request-search.component.css']
})
export class VactionRequestSearchComponent implements OnInit {
  vacnumber :any ;
  vacdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  vacempcode = '' ;
  empname = '';
  wk_DepartmentID = '';
  wk_DepartmentName = '';

  vackind = 'T' ;
  vactype = '' ;
  vacnote = '' ;
  vacaltemp = '' ;
  vacaltempname = '';
  vacapproved = '' ;
  wk_Approved = false;
  vacperiod = '' ;
  vactransList: VacationTransModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();

  constructor(public storage: LocalStorageService,
    public vactransactionservice : VacationTransService,
    public vactransaction : VacationTransModel,
    public doctorsservice : DoctorsService,
    public dialogRef: MatDialogRef<VactionRequestSearchComponent>,
    @Inject(MAT_DIALOG_DATA)
    private dialogref: MatDialog,
    public doctors : DoctorsModel,
    ) { }

  ngOnInit(): void {
    this.retriveVacTransTop();

  }
  retriveVacTransTop(){
    this.vactransList = [];
    this.vactransactionservice.GetVacationTransTop('T', this.storage.retrieve('stgcompCode')).subscribe((data: VacationTransModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.vactransList[i] = data[i];
        this.vactransList[i].vacdate = formatDate(data[i].vacdate, 'yyyy-MM-dd', 'en');
        this.doctorsservice.getdoctors(this.vactransList[i].vacempcode,this.storage.retrieve('stgcompCode')).subscribe(
          (data: DoctorsModel) => {
            this.vactransList[i].vacnote = data.docName
    }
    );

      }
    })

  }
  retriveVacTrans(){

  }
  SelectVacTrans(proj: VacationTransModel){

    this.vactransaction.vacnumber = proj.vacnumber;
 
    this.submitClicked.emit(this.vactransaction);
    this.dialogRef.close();
  }
}
